"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _DeconstructedURL_domain, _DeconstructedURL_extension, _DeconstructedURL_host, _DeconstructedURL_hostname, _DeconstructedURL_origin, _DeconstructedURL_port, _DeconstructedURL_protocol, _DeconstructedURL_subdomain;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeconstructedURL = void 0;
class DeconstructedURL {
    get domain() {
        return __classPrivateFieldGet(this, _DeconstructedURL_domain, "f");
    }
    set domain(value) {
        __classPrivateFieldSet(this, _DeconstructedURL_domain, value, "f");
        this.rebuildHostname();
    }
    get extension() {
        return __classPrivateFieldGet(this, _DeconstructedURL_extension, "f");
    }
    set extension(value) {
        __classPrivateFieldSet(this, _DeconstructedURL_extension, value, "f");
        this.rebuildHostname();
    }
    get host() {
        return __classPrivateFieldGet(this, _DeconstructedURL_host, "f");
    }
    set host(value) {
        this.parseHost(value);
    }
    get hostname() {
        return __classPrivateFieldGet(this, _DeconstructedURL_hostname, "f");
    }
    set hostname(value) {
        this.parseHostname(value);
    }
    get origin() {
        return __classPrivateFieldGet(this, _DeconstructedURL_origin, "f");
    }
    get port() {
        return __classPrivateFieldGet(this, _DeconstructedURL_port, "f");
    }
    set port(value) {
        __classPrivateFieldSet(this, _DeconstructedURL_port, value, "f");
        this.rebuildHostname();
    }
    get protocol() {
        return __classPrivateFieldGet(this, _DeconstructedURL_protocol, "f");
    }
    set protocol(value) {
        __classPrivateFieldSet(this, _DeconstructedURL_protocol, value, "f");
        this.rebuildOrigin();
    }
    get search() {
        const value = this.searchParams.toString();
        return value ? `?${value}` : '';
    }
    get subdomain() {
        return __classPrivateFieldGet(this, _DeconstructedURL_subdomain, "f");
    }
    set subdomain(value) {
        __classPrivateFieldSet(this, _DeconstructedURL_subdomain, value, "f");
        this.rebuildHostname();
    }
    constructor(url) {
        _DeconstructedURL_domain.set(this, void 0);
        _DeconstructedURL_extension.set(this, void 0);
        _DeconstructedURL_host.set(this, void 0);
        _DeconstructedURL_hostname.set(this, void 0);
        _DeconstructedURL_origin.set(this, void 0);
        _DeconstructedURL_port.set(this, void 0);
        _DeconstructedURL_protocol.set(this, void 0);
        _DeconstructedURL_subdomain.set(this, void 0);
        const parsedUrl = typeof url === 'string' ? new URL(url) : url;
        const { host, pathname, protocol, searchParams } = parsedUrl;
        this.pathname = pathname;
        this.protocol = protocol.toLowerCase();
        this.searchParams = searchParams;
        this.parseHost(host.toLowerCase());
    }
    parseHost(value) {
        var _a, _b, _c;
        let hostParts = value.split('.');
        // Special handling for feature environments (i.e. app.feature1.seesonar.com)
        if (hostParts.length >= 4) {
            const domainPart = hostParts.slice(1, hostParts.length - 1).join('.');
            hostParts = [hostParts[0], domainPart, hostParts[hostParts.length - 1]];
        }
        const isOnlyLocalhost = hostParts.length === 1;
        const hasSubdomain = !isOnlyLocalhost && hostParts.length === 3;
        let subdomain = hasSubdomain ? hostParts[0] : '';
        let domain = hasSubdomain ? hostParts[1] : hostParts[0];
        const extensionAndPort = hasSubdomain ? hostParts[2] : hostParts[1];
        let [extension, port] = (_a = extensionAndPort === null || extensionAndPort === void 0 ? void 0 : extensionAndPort.toLowerCase().split(':')) !== null && _a !== void 0 ? _a : [];
        if (extension === 'localhost') {
            subdomain = domain;
            domain = extension;
            extension = '';
        }
        if (domain.includes(':')) {
            [domain, port] = domain.split(':');
        }
        __classPrivateFieldSet(this, _DeconstructedURL_domain, domain.toLowerCase(), "f");
        __classPrivateFieldSet(this, _DeconstructedURL_extension, (_b = extension === null || extension === void 0 ? void 0 : extension.toLowerCase()) !== null && _b !== void 0 ? _b : '', "f");
        __classPrivateFieldSet(this, _DeconstructedURL_port, port !== null && port !== void 0 ? port : '', "f");
        __classPrivateFieldSet(this, _DeconstructedURL_subdomain, (_c = subdomain === null || subdomain === void 0 ? void 0 : subdomain.toLowerCase()) !== null && _c !== void 0 ? _c : '', "f");
        this.rebuildHostname();
    }
    parseHostname(value) {
        this.parseHost(__classPrivateFieldGet(this, _DeconstructedURL_port, "f") ? `${value}:${__classPrivateFieldGet(this, _DeconstructedURL_port, "f")}` : value);
    }
    rebuildHost() {
        __classPrivateFieldSet(this, _DeconstructedURL_host, __classPrivateFieldGet(this, _DeconstructedURL_port, "f") ? `${__classPrivateFieldGet(this, _DeconstructedURL_hostname, "f")}:${__classPrivateFieldGet(this, _DeconstructedURL_port, "f")}` : __classPrivateFieldGet(this, _DeconstructedURL_hostname, "f"), "f");
        this.rebuildOrigin();
    }
    rebuildHostname() {
        const hostnameParts = [];
        if (__classPrivateFieldGet(this, _DeconstructedURL_subdomain, "f")) {
            hostnameParts.push(__classPrivateFieldGet(this, _DeconstructedURL_subdomain, "f"));
        }
        hostnameParts.push(__classPrivateFieldGet(this, _DeconstructedURL_domain, "f"));
        if (__classPrivateFieldGet(this, _DeconstructedURL_extension, "f")) {
            hostnameParts.push(__classPrivateFieldGet(this, _DeconstructedURL_extension, "f"));
        }
        __classPrivateFieldSet(this, _DeconstructedURL_hostname, hostnameParts.join('.'), "f");
        this.rebuildHost();
    }
    rebuildOrigin() {
        __classPrivateFieldSet(this, _DeconstructedURL_origin, `${__classPrivateFieldGet(this, _DeconstructedURL_protocol, "f")}//${__classPrivateFieldGet(this, _DeconstructedURL_host, "f")}`, "f");
    }
    toString() {
        const path = this.pathname === '/' ? '' : this.pathname;
        return `${__classPrivateFieldGet(this, _DeconstructedURL_origin, "f")}${path}${this.search}`;
    }
    asURL() {
        return new URL(this.toString());
    }
}
exports.DeconstructedURL = DeconstructedURL;
_DeconstructedURL_domain = new WeakMap(), _DeconstructedURL_extension = new WeakMap(), _DeconstructedURL_host = new WeakMap(), _DeconstructedURL_hostname = new WeakMap(), _DeconstructedURL_origin = new WeakMap(), _DeconstructedURL_port = new WeakMap(), _DeconstructedURL_protocol = new WeakMap(), _DeconstructedURL_subdomain = new WeakMap();
//# sourceMappingURL=lib.js.map